import {Injectable,AfterViewInit} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {RequestConfig, RestResponse} from "../shared/rest/rest.request";
import {RequestMethod, Response} from "@angular/http";
import {Subject} from "rxjs/Subject";
import {isNullOrUndefined} from "util";
import {TaskView} from "../+tareas/task.service";
import {Answers, Formato} from "../+formatos/formatos.service";
import {Categoria} from "../+admin/+configuraciones/+tickets/+categorias/categorias.service";
import {TipoTicket} from "../+admin/+configuraciones/+tickets/+tipos-ticket/tipos.service";
import {TicketStatus} from "../+admin/+configuraciones/+tickets/+estatus/estatus.service";
import {CamposExtra} from "../+admin/+configuraciones/+tickets/+campos-extra/campos.service";
import {CustomHttp} from "../common/http/custom.http";
import {PageImpl} from "../common/http/PageImpl";
import { TaskViewEvents } from "app/+task/task.service";
import { BehaviorSubject } from "rxjs-compat";
import { SharedService } from "app/shared/shared.service";
import { catchError, map } from "rxjs/operators";
import { EngineeringRegistration } from "app/+task/details/task-details.component";
import {environment} from "../../environments/environment";

@Injectable()
export class TicketService implements AfterViewInit{
    public GET_CODE = new RequestConfig("TICK002", "application/json", true, RequestMethod.Get, "/tickets/{ticketId}");
    public GET_AGENDA_TICKET = new RequestConfig("TICK008", "application/json", true, RequestMethod.Get, "/agenda/{idTicket}");
    public GET_PAGE = new RequestConfig("TICK002", "application/json", true, RequestMethod.Get, "/tickets");
    public CREATE_CODE = new RequestConfig("TICK001", "application/json", true, RequestMethod.Post, "/tickets");
    public GET_EVENTS = new RequestConfig("TICK007", "application/json", true, RequestMethod.Post, "/tickets/events");
    public GET_CLONE_EVENTS = new RequestConfig("TICK007", "application/json", true, RequestMethod.Post, "/ticket/report/events");
    public GET_ALL = new RequestConfig("TICK006", "application/json", true, RequestMethod.Post, "/tickets/toAssign");
    public EDIT_CODE = new RequestConfig("TICK003", "application/json", true, RequestMethod.Put, "/tickets/{ticketId}");
    public PROCESS_TICKET = new RequestConfig("TICK003", "application/json", true, RequestMethod.Put, "/tickets/{ticketId}/{process}");
    public CLOSE_TICKET = new RequestConfig("TICK003", "application/json", true, RequestMethod.Put, "/tickets/{idTicket}/close");
    public SAVE_RESULT = new RequestConfig("FTS005", "application/json", true, RequestMethod.Post, "/formats/result/{idFormat}");
    public ADVANCE_SEARCH = new RequestConfig("FTS008", "application/json", true, RequestMethod.Post, "/tickets/find");
    public MATCH_SUMMARY = new RequestConfig("FTS009", "application/json", true, RequestMethod.Post, "/tickets/resumenJornada");

    public DASBOARD_GRAFIC = new RequestConfig("FTS008", "application/json", true, RequestMethod.Get, "/tickets/ultimos5-dash");
    public GET_USER_SESSION_HISTORY = new RequestConfig("FTS008", "application/json", true, RequestMethod.Get, "/user-session-history/cuadrillas-login-fecha-dash");

    private GET_PRIORITIES = new RequestConfig("TICK010", "application/json", true, RequestMethod.Get, "/priority-catalog");
    private GET_FORMAT = new RequestConfig("TICK010", "application/json", true, RequestMethod.Get, "/formats/all");
    private GET_FORMAT_VALIDATE = new RequestConfig("TICK010", "application/json", true, RequestMethod.Get, "/formats/validarRegistroVehicular");
    private GET_TICKET_ENDPLANNED = new RequestConfig("TICK010", "application/json", true, RequestMethod.Get, "/tickets/atiende-antes-planeado-dash");
    private UNASSING = new RequestConfig("TICK009", "application/json", true, RequestMethod.Put, "/tickets/unassign");
    private UNASSING_ALL = new RequestConfig("TICK009", "application/json", true, RequestMethod.Put, "/tickets/unassign/all");
    private CANCEL_TICKET = new RequestConfig("TICK009", "application/json", true, RequestMethod.Put, "/tickets/{idTicket}/cancel");
    private GET_AGENDA_CALENDAR = new RequestConfig('TC103', 'application/json', true, RequestMethod.Get, '/tickets/busy-hours/agenda', true);
    private RESCHEDULE_TICKET = new RequestConfig('TC103', 'application/json', true, RequestMethod.Put, '/tickets/scheduled', false);
    private GET_TICKET: RequestConfig = new RequestConfig('TC001', 'application/json', true, RequestMethod.Get, '/tickets/{idTicket}', true);
    public GET_CCN_TICKETS = new RequestConfig("TICK020", "application/json", true, RequestMethod.Post, "/tickets/ccnReport");
    private GET_EVIDENCE_QUEJA = new RequestConfig("EQ001", "application/json", true, RequestMethod.Post, "/imagenesQuejas",true);
    private GET_EVIDENCE_SUPERVISOR = new RequestConfig("EQ001", "application/json", true, RequestMethod.Post, "/evidenciaSupervisor",true);
    private GET_EVIDENCE_SALE = new RequestConfig("EQ001", "application/json", true, RequestMethod.Post, "/evidenciaFachada",true);
    private GET_EVENTS_SUPERVISOR = new RequestConfig("EQ001", "application/json", true, RequestMethod.Post, "/bitacora_tickets",true);
    private GET_PROBLEMAS = new RequestConfig("EQ001", "application/json", true, RequestMethod.Get, "/tickets/getProblemas?type=2",true);
    private GET_SUBPROBLEMAS = new RequestConfig("EQ001", "application/json", true, RequestMethod.Get, "/tickets/getSubProblemas?type=2",true);
    private POST_BITACORA_INC = new RequestConfig("EQ001", "application/json", true, RequestMethod.Post, "/tickets/saveBiacoraInc",true);
    private POST_GEOPOSICION_CHERWELL: RequestConfig = new RequestConfig('EQ002', 'application/json', true, RequestMethod.Post, '/tickets/geoposicionCherwell', true);
    private GET_FIBERS_AND_KMS = new RequestConfig("FM001", "application/json", true, RequestMethod.Get, "/registroIngenierias/{idTicket}",true);
    private POST_FIBERS_AND_KMS_CLOSE = new RequestConfig("FM002", "application/json", true, RequestMethod.Post, "/tickets/fibrasCierre",true);
    private POST_TICKETS_CUADRILLA = new RequestConfig('TC103', 'application/json', true, RequestMethod.Post, '/tickets/cuadrilla', true);
    private POST_TICKETS_CUADRILLA_CLONE = new RequestConfig('TC103', 'application/json', true, RequestMethod.Post, '/ticket/report/cuadrilla', true);
    private GET_TICKETS_ALERTAS = new RequestConfig('TC103', 'application/json', true, RequestMethod.Get, '/notification/number', true);
    private POST_CLOSE_CLASIFICATION = new RequestConfig("FM002", "application/json", true, RequestMethod.Post, "/tickets/fallasMasivas",true);
    private POST_ALLOW_ATTENTION = new RequestConfig("FM006", "application/json", true, RequestMethod.Post, "/tickets/allowAttention",true);
    private POST_RED_FLAGS_DATA = new RequestConfig('TC103', 'application/json', true, RequestMethod.Post, '/guardaBanderaRoja', true);
    private POST_FIBRAS_PLANEADAS = new RequestConfig("EQ002", "application/json", true, RequestMethod.Post, "/tickets/fibrasPlaneadas",true);
    private CHECK_ALLOWED_HOURS = new RequestConfig("GRP001", "application/json", true, RequestMethod.Get, "/groups/allowed", true);
    private GET_FOLIOS_MTTO = new RequestConfig('TICK008', 'application/json', true, RequestMethod.Get, '/ticketsFolioSucursal', true);
    private GET_FOLIO = new RequestConfig('TICK008', 'application/json', true, RequestMethod.Get, '/tickets/folio/sucursal', true);
    private GET_FOLIOS_MTTO_LIVE_TRACKING = new RequestConfig('TICK008', 'application/json', true, RequestMethod.Get, '/tickets/mtto/folio', true);
    private POST_CUADRILLAS_FOLIOS = new RequestConfig('TICK008', 'application/json', true, RequestMethod.Post, '/tickets/mtto/usuarios/folios', true);


    public tickets: Subject<any>;
    public activeFolder: Subject<any>;
    public currentTicket: Subject<any>;
    public pageSize: number = 100;
    public currentPage: number = 0;
    public maxPages: number = 0;
    public canAssign: boolean = false;
    public canCancel: boolean = false;
    public hideAdvance: boolean = false;
    private state = {
        lastFolder: '',
        tickets: []
    };

    public TICKET_FLOW = [];

    public folders: any = [
        {
            "key": "new",
            "name": "New"
        },
        {
            "key": "assigned",
            "name": "Assigned"
        },
        {
            "key": "inProgress",
            "name": "In progress",
        },
        {
            "key": "cancelled",
            "name": "Cancelled"
        },
        {
            "key": "solved",
            "name": "Solved"
        },
        {
            "key": "closed",
            "name": "Closed"
        },
        {
            "key": "",
            "name": "In Progress"
        },
        {
            "key": "all",
            "name": ""
        },
        {
            "key": "reopen",
            "name": "Reabierto"
        }
    ];
    public ticketsccn = [];

    constructor(private http: CustomHttp, private sharedService:SharedService) {
        this.tickets = new Subject();
        this.activeFolder = new Subject();
        this.currentTicket = new Subject();
        this.TICKET_FLOW['assign'] = 'assign';
        this.TICKET_FLOW['cancel'] = 'cancel';
        this.TICKET_FLOW['start'] = 'confirm';
        this.TICKET_FLOW['solve'] = 'solve';
        this.TICKET_FLOW['close'] = 'close';
        this.TICKET_FLOW['reopen'] = 'close';
        this.TICKET_FLOW['restart'] = 'restart';
        this.TICKET_FLOW['suspend'] = 'suspend';
    }
    
    ngAfterViewInit(){
        $("#opciones").on("click",function(){
            alert('Función on() activada.');
        });
    }


    createTicket(ticket: any): Observable<TicketView> {
        return this.http.sendRequest(this.CREATE_CODE, ticket)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    reschedule(reschedule: TicketReschedule): Observable<any> {
        return this.http.sendRequest(
            this.RESCHEDULE_TICKET,
            {
                idTicket: reschedule.idTicket,
                scheduledDate: reschedule.scheduledDate
            }
        );
    }

    getTicketPage(searchOptions?: any) {
        if (searchOptions.folder && searchOptions.folder !== '') {
            let folder = this.folders.find(f => f.key == searchOptions.folder);
            searchOptions.statusValue = folder.name;
        }
        if (searchOptions) {
            searchOptions.size = this.pageSize;
            searchOptions.page = this.currentPage;
        } else {
            searchOptions = {
                size: this.pageSize,
                page: this.currentPage
            }
        }
        this.http.sendRequest(this.GET_CODE, searchOptions)
            .map((res): Response => {
                this.maxPages = res.json().totalElements;
                this.state.lastFolder = isNullOrUndefined(searchOptions.folder) ? '' : searchOptions.folder;
                this.state.tickets = res.json();
                this.activeFolder.next(isNullOrUndefined(searchOptions.folder) ? '' : searchOptions.folder);
                this.tickets.next(this.state.tickets);
                return res.json();
            })
            .catch(error => this.http.handleError(error))
            .subscribe();
        this.hideAdvance = true;
    }

    getPage(options: any): Observable<PageImpl<TicketView>> {
        return this.http.sendRequest(this.GET_PAGE, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
    agendaticket(options: any):Observable<AgendaHours[]> {
       
        return this.http.sendRequest(this.GET_AGENDA_CALENDAR,options)
        .map(res => res.json())
        .catch(error => this.http.handleError(error));
    }

    getDashboardInfo(): Observable<GraficDashboard> {
        return this.http.sendRequest(this.DASBOARD_GRAFIC)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getUsersSessionHistory(idUserApp:number,selectDate:number): Observable<any> { //userSessionHistory: UserSessionHistory
        let body: any;
        body = {idUserApp: idUserApp,selectDate: selectDate};
        return this.http.sendRequest(this.GET_USER_SESSION_HISTORY,body)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getAllTickets(options: ToAssign): Observable<ToAssign> {
        return this.http.sendRequest(this.GET_ALL, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getEvents(options: any): Observable<Array<EventList>> {
        return this.http.sendRequest(this.GET_EVENTS, options)
            .map(res => this.processCustomerNames(res.json(),3))
            .catch(error => this.http.handleError(error));
    }
    getCloneDbEvents(options: any): Observable<Array<EventList>> {
        return this.http.sendRequest(this.GET_CLONE_EVENTS, options)
            .map(res => this.processCustomerNames(res.json(),3))
            .catch(error => this.http.handleError(error));
    }
     getEventsSupervisor(request: any): Observable<any> {
        return this.http.sendRequestApiMega(this.GET_EVENTS_SUPERVISOR, request)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getAgendaTicket(ticketId: number): Observable<TicketView> {
        return this.http.sendRequest(this.GET_CODE, {}, ticketId)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    get(ticketId: any) {
        this.http.sendRequest(this.GET_CODE, {}, ticketId)
            .map((res): Response => res.json())
            .do(data => {
                this.currentTicket.next(this.processCustomerNames(data, 2));
            }).catch(error =>
            this.http.handleError(error)
        ).subscribe(
            success => {
            },
            error => this.currentTicket.error(error)
        );
    }

    setPage(value: number) {
        this.currentPage = value;
    }

    setSize(value: number) {
        this.pageSize = value;
    }

    closeTicket (request: CloseView, idTicket: number): Observable<any> {
        return this.http.sendRequest(this.CLOSE_TICKET, request, idTicket)
            .catch(this.http.handleError);
    }

    processTicket(code: string, ticketId: number, body: any): Observable<any> {
        let uri = this.TICKET_FLOW[code];
        return this.http.sendRequest(this.PROCESS_TICKET, body, ticketId, uri)
            .map((res) => {
                try {
                    return res.json();
                } catch (error) {

                }
            })
            .catch(error => this.http.handleError(error));
    }

    parseDate(date: string, hour: string) {
        let partTime = date.split('-');
        let hourPart = hour.split(":");
        return new Date( parseInt(partTime[0]),  parseInt(partTime[1]) - 1,  parseInt(partTime[2]),  parseInt(hourPart[0]),  parseInt(hourPart[1]), 0, 0);
    }

    sendAnswers(request: Answers, idFormat: number) {
        return this.http.sendRequest(this.SAVE_RESULT, request, idFormat)
            .catch(error => this.http.handleError(error));
    }

    advanceSearchTicket(options: TicketAdvanceSearch): Observable<PageImpl<TicketView>> {
        options.dimme = true;
        return this.http.sendRequest(this.ADVANCE_SEARCH, options)
            .map(res => this.processCustomerNames(res.json(),1))
            .catch(error => this.http.handleError(error));
    }
    processCustomerNames(data:any, opc:number):any{
        let response:any = data;
        let newArray: any[] = [];
        if(opc && opc == 1)
        {
            if (response && response.content && response.content.length > 0) {
                response.content.forEach((ticket: any) => {
                    if(ticket.customerData.nameComplete != "N/A" && ticket.customerData.nameComplete){
                        let newCustomerInfo = this.sharedService.getNewCustomerInfo(ticket.customerData.customerInfo);
                        ticket.customerData.customerInfo = newCustomerInfo;
                        ticket.customerData.nameComplete = this.sharedService.getNameComplete(ticket.customerData.customerInfo);
                       
                    }
                    newArray.push(ticket);
                });
                response.content = newArray;
            } 
        }
        else if(opc && opc == 3)
        {
            if (response && response.length > 0) {
                response.forEach((shedule: any) => {
                    let newValue = {...shedule};
                    if(newValue.ticket.customerData.nameComplete != "N/A" && newValue.ticket.customerData.nameComplete){
                        let newCustomerInfo = this.sharedService.getNewCustomerInfo(newValue.ticket.customerData.customerInfo);
                        newValue.ticket.customerData.customerInfo = newCustomerInfo;
                        newValue.ticket.customerData.nameComplete = this.sharedService.getNameComplete(newValue.ticket.customerData.customerInfo);
                        
                    }
                    newArray.push(newValue);
                   
                });
                response = newArray;
            } 
        }
        else {
            if (response && response.customerData && response.customerData.customerInfo) {
                if(response.customerData.nameComplete != "N/A" && response.customerData.nameComplete){
                    let newCustomerInfo = this.sharedService.getNewCustomerInfo(response.customerData.customerInfo);
                    response.customerData.customerInfo = newCustomerInfo;
                    response.customerData.nameComplete = this.sharedService.getNameComplete(response.customerData.customerInfo);
                }
               
            }
        }
        
        return response;
    }

    updateTicket(request: TicketUpdateRequest, ticketId: number): Observable<any> {        
        return this.http.sendRequest(this.EDIT_CODE, request, ticketId)
            .catch(this.http.handleError);
    }

    updateTicket2(request: TicketUpdateRequest, ticketId: number): Observable<any> {        
        return this.http.sendRequest(this.EDIT_CODE, request, ticketId)
        .map(res => res.json())
            .catch(this.http.handleError);
    }

    getPriorities(): Observable<TicketPriority[]> {
        let priorityCatalog: any = localStorage.getItem('priorityCatalog');
        if (priorityCatalog != undefined || priorityCatalog != null) {
            let priorityCatalogParse = JSON.parse(priorityCatalog)
            if (priorityCatalogParse != undefined) {
                let newData = new BehaviorSubject<any>(null);
                newData.next(priorityCatalogParse)
                return newData;
            }
        }
        else {
            return this.http.sendRequest(this.GET_PRIORITIES)
            .map((res:any) => {
                    try {
                        localStorage.setItem('priorityCatalog', res._body);
                        return res.json();
                    } catch (e) {
                        return e => this.http.handleError(e);
                    }
                })
        };

        // return this.http.sendRequest(this.GET_PRIORITIES)
        //     .map(res => res.json())
        //     .catch(error => this.http.handleError(error));
    }

    getAllFormats(): Observable<FormatView[]>{
        return this.http.sendRequest(this.GET_FORMAT)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
    getValidarFormato(username:any,idFormato:any): Observable<any>{
        
        let body = {userName: username, idFormat: idFormato};
        console.log('dattos',body)
        // return this.http.sendRequest(this.GET_FORMAT_VALIDATE,body)
        //     .map(res => res.json())
        //     .catch(error => this.http.handleError(error));
        return this.http.sendRequest(this.GET_FORMAT_VALIDATE,body)
       .map(res => res.json())
       .catch(error => this.http.handleError(error));
    }
    getTicketPlannedStart(assignee, startDate ): Observable<TicketTerminados[]>{
        let body = {assignee: assignee, startDate: startDate};
        return this.http.sendRequest(this.GET_TICKET_ENDPLANNED, body)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    unassignTicket(unassign: Unassign){
        return this.http.sendRequest(this.UNASSING, unassign)
            .catch(error => this.http.handleError(error));
    }

    cancelTicket(idTicket: number, view: CancelTicketView): Observable<any> {
        return this.http.sendRequest(this.CANCEL_TICKET, view, idTicket)
            .catch(this.http.handleError);
    }

    unassignAllTickets(unassignAll: UnassignAll) {
        return this.http.sendRequest(this.UNASSING_ALL, unassignAll)
            .catch(error => this.http.handleError(error));
    }

    getTicketServer(idTicket: any): Observable<any> {
        console.log('llega',idTicket)
       return this.http.sendRequest(this.GET_TICKET, null,idTicket)
       .map(res => this.processCustomerNames(res.json(), 2))
       .catch(error => this.http.handleError(error));
   }

   getccnTicket(idUsers: any): Observable<any> {
    return this.http.sendRequest(this.GET_CCN_TICKETS, idUsers)
        .map(res => res.json())
        .catch(error => this.http.handleError(error));
    }

    setTicketsccn(tickets: any){
        this.ticketsccn = tickets
    }

    getTicketsccn(){
        return this.ticketsccn
    }

    getColorSemaforoTicket(createdDate?: any, ticketCategoryId?: number) {
        let dateNow = new Date().getTime();
        let color = "";
        let result = (dateNow - createdDate) / (1000 * 60 * 60 * 24);
        result = Math.floor(result);
        const tipo1: any = [
            { color: '', minDias: 0, maxDias: 7, },
            { color: 'semaforoGreen', minDias: 8, maxDias: 15, },
            { color: 'semaforoYellow', minDias: 16, maxDias: 30, },
        ];
        const tipo2: any = [
            { color: '', minDias: 0, maxDias: 1, },
            { color: 'semaforoGreen', minDias: 2, maxDias: 4, },
            { color: 'semaforoYellow', minDias: 5, maxDias: 7, },
        ];
        const tipo48: any = [
            { color: '', minDias: 0, maxDias: 1, },
            { color: 'semaforoGreen', minDias: 2, maxDias: 4, },
            { color: 'semaforoYellow', minDias: 5, maxDias: 7, },
        ];
        switch (ticketCategoryId) {
            case 1:
                let colorFind = tipo1.find((colorFind: any) => {
                    return result >= colorFind.minDias && result <= colorFind.maxDias;
                });
                colorFind != undefined ? color = colorFind.color : result > tipo1[2].maxDias ? color = 'semaforoOrange' : color = '';
                break;
            case 2:
                let colorFind2 = tipo2.find((colorFind2: any) => {
                    return result >= colorFind2.minDias && result <= colorFind2.maxDias;
                });
                colorFind2 != undefined ? color = colorFind2.color : result > tipo2[2].maxDias ? color = 'semaforoOrange' : color = '';
                break;
            case 48:
                let colorFind48 = tipo48.find((colorFind48: any) => {
                    return result >= colorFind48.minDias && result <= colorFind48.maxDias;
                });
                colorFind48 != undefined ? color = colorFind48.color : result > tipo48[2].maxDias ? color = 'semaforoOrange' : color = '';
                break;
        }
        return color;
    }
    resumenJornada(listIdTicket: any): Observable<PageImpl<TicketView>> {
        const listTickets = listIdTicket;
        return this.http.sendRequest(this.MATCH_SUMMARY, listTickets)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getEvidenciaQueja(request: any): Observable<any> {
        return this.http.sendRequestApiMega(this.GET_EVIDENCE_QUEJA, request)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getEvidenciaSupervisor(request: any): Observable<any> {
        return this.http.sendRequestApiMega(this.GET_EVIDENCE_SUPERVISOR, request)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
    getEvidenciaSale(request: any): Observable<any> {
        return this.http.sendRequestApiMega(this.GET_EVIDENCE_SALE, request)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    

    getProblemas(): Observable<any> {
        return this.http.sendRequest(this.GET_PROBLEMAS)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getSubProblemas(): Observable<any> {
        return this.http.sendRequest(this.GET_SUBPROBLEMAS)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    saveBitacoraInc(body: any): Observable<any> {
        return this.http.sendRequest(this.POST_BITACORA_INC, body).pipe(
            map(res => res || true),
            catchError(error => this.http.handleError(error))
        );
    }

    geoposicionCherwell(body: GeoPosicionCherwellRequest): Observable<any> {
        return this.http.sendRequest(this.POST_GEOPOSICION_CHERWELL, body).pipe(
            map(res => res || true),
            catchError(error => this.http.handleError(error))
        );
    }

    getFibersAndKms(idTask: number): Observable<RegistrosIngenieria[]> {
        return this.http.sendRequestApiMega(this.GET_FIBERS_AND_KMS, null, idTask)
            .map(res => {
                const data: FibersAndKms[] = res.json();
                return res.json() ? this.getDataMapBuferHilos(data) : [];
            })
            .catch(error => this.http.handleError(error));
    }

    getDataMapBuferHilos(data: FibersAndKms[]) {
        const sorted = [...data].sort((a, b) => new Date(a.fecha_registro).getTime() - new Date(b.fecha_registro).getTime());
        let tareaCounter = 1;
        let tareasMap: RegistroIngenieria[] = [];
        let registrosIngenieria: RegistrosIngenieria[] = [];
        sorted.forEach(item => {
            const folio = item.folio_trabajo ? item.folio_trabajo : `Tarea de apoyo ${tareaCounter++}`;
            const latitud = item.latitud;
            const longitud = item.longitud;
            const fibraEntrada = item.fibra_entrada;
            const kmEntrada = item.km_entrada;

            for (let i = 1; i <= 16; i++) {
                const key = `fibra_contador${i}` as keyof typeof item;
                const contador = item[key];
                if (contador && typeof contador === 'object' && Array.isArray(contador.buferHilo)) {
                    contador.buferHilo.forEach(bh => {
                        const registro: RegistroIngenieria = {
                            folio,
                            latitud,
                            longitud,
                            fibraEntrada,
                            kmEntrada,
                            position: contador.posicion,
                            fibraSalida: contador.fibraSalida,
                            kmSalida: contador.kmSalida,
                            bufferEntrada: bh.buferEntrada,
                            hiloEntrada: bh.hiloEntrada,
                            bufferSalida: bh.buferSalida,
                            hiloSalida: bh.hiloSalida
                        };
                        tareasMap.push(registro);
                    });
                }
            }
            registrosIngenieria.push({
                folio: folio,
                registros: tareasMap
            });
            tareasMap = [];
        });
        return registrosIngenieria && registrosIngenieria.length ? registrosIngenieria : [];
    }

    postFibersAndKmsClose(fibersAndKmsClose: postFibersAndKmsClose): Observable<any> {
        return this.http.sendRequest(this.POST_FIBERS_AND_KMS_CLOSE, fibersAndKmsClose, null)
            .map(res => {
                return res;
            })
            .catch(error => this.http.handleError(error));
    }

    ticketsCuadrilla(idGroup?: number[]): Observable<TicketView[]> {
        const body = { idGroup };
        return this.http.sendRequest(this.POST_TICKETS_CUADRILLA, body).pipe(
            map(res => res.json()),
            catchError(error => this.http.handleError(error))
        );
    }

    ticketsCuadrillaClone(idGroup?: number[]): Observable<TicketView[]> {
        const body = { idGroup };
        return this.http.sendRequest(this.POST_TICKETS_CUADRILLA_CLONE, body).pipe(
            map(res => res.json()),
            catchError(error => this.http.handleError(error))
        );
    }


    postCloseClasification(closeClasification: CloseClasification): Observable<any> {
        return this.http.sendRequest(this.POST_CLOSE_CLASIFICATION, closeClasification, null)
            .map(res => {
                return res;
            })
            .catch(error => this.http.handleError(error));
    }

    postAllowAtention(idTickets: number[]): Observable<any> {
        return this.http.sendRequest(this.POST_ALLOW_ATTENTION, { idTickets: idTickets }, null)
            .map(res => {
                return res;
            })
            .catch(error => this.http.handleError(error));
    }

    PostRedFlagsData(redFlagsData: PostRedFlagsData): Observable<RegistrosIngenieria[]> {
        return this.http.sendRequestApiMega(this.POST_RED_FLAGS_DATA, redFlagsData, null)
            .map(res => {
                return res.json();
            })
            .catch(error => this.http.handleError(error));
    }

    postFibrasPlaneadas(fibrasPleandasRequest: FibrasPleandasRequest): Observable<void> {
        return new Observable<void>((subscriber) => {
            this.http.sendRequest(
                this.POST_FIBRAS_PLANEADAS,
                fibrasPleandasRequest
            ).subscribe({
                next: () => {
                    subscriber.next();
                    subscriber.complete();
                },
                error: (error) => {
                    console.log(error);
                    subscriber.error(error);
                }
            });
        });
    }

    updateExtraInfoListTicket(extraInfoList: any, idPriority: number, ticketId: number, priority?: any): Observable<any> {
        let request: any = { extraInfoList, idPriority };
        if (priority) {
            request = { ...request, priority: priority };
        }
        return this.http.sendRequest(this.EDIT_CODE, request, ticketId)
            .catch(this.http.handleError);
    }

    checkAllowedHours(sucursal: string, startHour: string = '07:00', endHour: string = '08:00'): Observable<AllowedHoursResponse> {
        const params = `?startHour=${encodeURIComponent(startHour)}&endHour=${encodeURIComponent(endHour)}&sucursal=${encodeURIComponent(sucursal)}`;
        const config = { ...this.CHECK_ALLOWED_HOURS };
        config.uri = config.uri + params;
        return this.http.sendRequest(config)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getFoliosMtto(params: {
        folio: number;
        sucursal: number;
        grupo: number;
    }): Observable<any> {

        return this.http
            .sendRequestToUrl(environment.API_MEGA_2,this.GET_FOLIOS_MTTO, params)
            .map(res => this.processCustomerNames(res.json(), 2))
            .catch(error => this.http.handleError(error));
    }

    getFolio(params: {
        idGroup: number;
        folio?: number;
        idTicketCherwell?: number;
    }): Observable<any> {

        return this.http
        .sendRequest(this.GET_FOLIO, params)
        .map(res => {
            const body = res.text();

            if (!body) {
                return null;
            }

            return this.processCustomerNames(JSON.parse(body), 2);
        })
        .catch(error => this.http.handleError(error));
    }

    getFoliosMttoLiveTracking(params: {
        folio: number;
        tipoTrabajo: number;
        sucursal: number;
    }): Observable<any> {

        return this.http
            .sendRequestToUrl(environment.api_url,this.GET_FOLIOS_MTTO_LIVE_TRACKING, params)
            .map(res => this.processCustomerNames(res.json(), 2))
            .catch(error => this.http.handleError(error));
    }

    getCuadrillasFolios(params: {
        sucursalesUsuarios: {
            sucursal: number;
            usuarios: string[];
        }[];
        tipoTrabajo?: number;
    }): Observable<any> {

        return this.http
            .sendRequest(
                this.POST_CUADRILLAS_FOLIOS,
                params
            )
            .map(res => {
            const body = res.text();

            if (!body) {
                return null;
            }

            return this.processCustomerNames(JSON.parse(body), 2);
        })
        .catch(error => this.http.handleError(error));
    }
}
export class PostRedFlagsData {
    sucursal: string;
    folio: string;
    tipo_trabajo: string;
    banderaRoja: string;
}
export class postFibersAndKmsClose {
    idTicket: number;
    fibras: string;
}
export interface RegistrosIngenieria {
    folio: string;
    registros: RegistroIngenieria[];
}
export interface RegistroIngenieria {
    folio: string;
    latitud: number;
    longitud: number;
    fibraEntrada: string;
    kmEntrada: number;
    position: number;
    fibraSalida: string;
    kmSalida: string;
    bufferEntrada: string;
    hiloEntrada: string;
    bufferSalida: string;
    hiloSalida: string;
};
export interface FibersAndKms {
    id_registro: number;
    folio: string;
    folio_trabajo: string;
    region: string;
    sucursal: number;
    nombre_sucursal: string;
    latitud: number;
    longitud: number;
    fibra_entrada: string;
    km_entrada: number;
    id_task: number;
    id_ticket: number;
    cantidad_ce: number;
    fecha_registro: string;
    fibra_contador1: FibraContador | string;
    fibra_contador2: FibraContador | string;
    fibra_contador3: FibraContador | string;
    fibra_contador4: FibraContador | string;
    fibra_contador5: FibraContador | string;
    fibra_contador6: FibraContador | string;
    fibra_contador7: FibraContador | string;
    fibra_contador8: FibraContador | string;
    fibra_contador9: FibraContador | string;
    fibra_contador10: FibraContador | string;
    fibra_contador11: FibraContador | string;
    fibra_contador12: FibraContador | string;
    fibra_contador13: FibraContador | string;
    fibra_contador14: FibraContador | string;
    fibra_contador15: FibraContador | string;
    fibra_contador16: FibraContador | string;
}

export interface FibraContador {
    kmSalida: string;
    posicion: number;
    fibraSalida: string;
    buferHilo: BuferHilo[];
}

export interface BuferHilo {
    hiloSalida: string;
    buferSalida: string;
    hiloEntrada: string;
    buferEntrada: string;
}


export class TicketTerminados{
   public antesTiempo: number;
   public assignee: string;
   public total: number;
}

export class TicketPage {
    public content: Array<TicketView> = [];
    public first: boolean;
    public last: boolean;
    public number: number;
    public numberOfElements: number;
    public size: number;
    public totalElements: number;
    public totalPages: number;

}
export class AgendaHours {
    startDate: any;
    endDate: any;
}
export class SearchPage<T> {
    public content: Array<T> = [];
    public first: boolean;
    public last: boolean;
    public number: number;
    public numberOfElements: number;
    public size: number;
    public totalElements: number;
    public totalPages: number;
}

export class TicketView {
    public assignee: string;
    public idUserApp: number;
    public cancelledDate: Date;
    public cancelledReason: string;
    public channel: string;
    public closeDate: Date;
    public closingComments: string;
    public createdDate: Date = new Date();
    public description: string;
    public customerData: CustomerData = new CustomerData();
    // public format: Array<formatTicket> = [];
    public formatResults: Array<FormatResultView> = [];
    public folio: string;
    public group: string;
    public idGroup: number;
    public idTicket: number;
    public idTicketParent: number;
    public idPriority: number;
    public idCloseCategory: number;
    public idCloseSubcategory: number;
    public closeCategoryName: string;
    public closeSubcategoryName: string;
    public labels: Array<LabelTicket> = [];
    public plannedEndDate: Date;
    public plannedStartDate: Date;
    public priority: string;
    public remainingTime: number;
    public startDate: Date;
    public summary: string;
    public workingTime: number;
    public ticketType: TipoTicket = new TipoTicket();
    public ticketCategory: Categoria = new Categoria();
    public ticketStatus: TicketStatus;
    public extraInfoList: Array<TicketExtraInfo> = [];
    // public formatResultViews: Array<FormatResultView> = [];
    public ticketStatusValue: string;
    //solo se usa en las vistas, no se envia en request
    public selected: boolean = false;
    public callTable: boolean = false;
    public tasks: Array<TaskView> = [];
    idSubcategory: number;
    public externalId: string;
    public extra1: string;
    public extra2: string;
    public extra3: string;
    public resolutionTime: number;
    public subcategoryName: string;
    public solveDate: Date;
    public numberVisits: number;
    public requesterName: any;
    public requesterUserName: any;
    public sucursal: string;
    public idUserAllocator?: number;
    public allocatorName?: string;
    public latitude?: number;
    public longitude?: number;
    public statusVisual?: any;
    public exceso?: any;
    public rango?: any;
}

export class TicketPriority {
    idPriority: number;
    number: number;
    description: string;
    color: string;
    enable: boolean;
}

export class CustomerData {
    public idCustomerData: number;
    public idExternalCustomer: number;
    public customerInfo: Array<CustomerExtraInfo> = [];
    nameComplete: string;
    commercialName: string;

    
}

export class CustomerExtraInfo {
    public key: string;
    public legend: string;
    public value: string;
}

export class LabelTicket {
    public idLabel: number;
    public label: string;
}

export class FormatView {
    public active:	boolean;
    public categoryName: string;
    public formatType: string;
    public idFormat: number;
    public title: string;
    public version: number;
}

// export class formatTicket {
//     idFormat: number;
//     title: string;
// }
export class FormatResultView {
    createdDate: Date;
    deviceId: string;
    formatView: Formato = new Formato();
    idFormatResult: number;
    jsonAnswer: any;
    taskView: any;
    ticketView: any;
    username: string;

    formatAnswers: Array<FormatAnswerView> = [];
}


export class FormatAnswerView {
    idFormatAnswer: number;
    key: string;
    valueText: string;
    askId: string;
}

export class TicketExtraInfo {
    public idTicketExtraInfo?: number;
    public key: string;
    public value: any;
    public legend: string;
    public legendArray?: Array<TicketExtraInfo>;
    public valueArray?: Array<TicketExtraInfo>;
    public fieldDefinition?: CamposExtra = new CamposExtra();
}

export class AssignmentView {
    assignee: string;
    assigneeName: string;
    group: string;
    idGroup: number;
    plannedEndDate: any;
    plannedStartDate: any;
    idUserApp: number;
    assignedTask?: boolean;
    started?: boolean;
}

export class RequesterView {
    name: string;
    username: string;
}

export class CancelView {
    cancelReason: string;
    deviceId:	string;
    externalCancel:	boolean;
    requester: any;
}

export class CloseRequestView {
    public commentsClose: string;
    public reopenTicket: boolean = false;
}

export class CloseView {
    idCloseCategory: number;
    idCloseSubcategory: number;
    commentsClose:	string;
    dateClose:	number;
    dateSolved?: number;
    deviceId:	string;
    reopenTicket: boolean;
    flow: string;
    requester: RequesterView = new RequesterView;
    causaProblemaMtto?: any;
    causaProblemaName?: string;
    motivoIncumplimiento?: string;
}
export class CommentView {
    activityType: string;
    comment: string;
    commentDate: any;
    commentName: string;
    commentUsername: string;
    idComment: number;
    img: any;
    attachments: Array<AttachmentView> = [];
    fechaTemporal: any;
    commentVisibility?: string;
    idTicket?: number;
    idTask?: number;
    solicitudVenta?: any;
    user?: boolean;
    engineering_registration: EngineeringRegistration;
    deviceId: any;
}

export class AttachmentView {
    contentType: string;
    fileB64Content: string;
    fileName: string;
    idAttachment: number;
    size: number;
    uploadDate: any;
    fileSystemPath?: string;
    fileSystemPathAlfresco?: string;
    idComment?: number;
    code?: Code;
}

export enum Code {
    INE_FRONTAL = 1,
    RECIBO_LUZ = 2,
    INE_TRASERA = 3,
    FOTO_EVIDENCIA = 10,
    FOTO_FACHADA = 4,
    FOTO_COMPETENCIA = 5,
    FOTO_ARRENDAMIENTO = 6,
    FOTO_EXTRAUNO = 7,
    FOTO_EXTRADOS = 8,
    FOTO_EXTRATRES = 9,
    FOTO_FIRMA = 11,
    CONSTANCIA_FISCAL = 14,
    FOTO_PASAPORTE = 15,
}

export class FormatAnswers {
    askId: string;
    key: string;
    valueText: string;
}

export class AnswersTicketView {
    idTicket: number;

    constructor(idTicket?: number) {
        if (idTicket) this.idTicket = idTicket;
    }
}

export class ToAssign {
    summary: string;
    idTicket: number;
    customerName: string;
    statusValue: string;
    ticketTypeName: string;
    date1: string;
    date2: string;
    generalSearch: boolean = true;
}

export class Events {
    idUsers: Array<string> = [];
    date: string;
}

export class EventList {
    idAgenda: number;
    idGroup: number;
    plannedStartDate: string;
    plannedEndDate: string;
    ticketStatus: string;
    assignee: string;
    group: string;
    ticket: TicketView;
    tasks: Array<TaskViewEvents> = [];
}

export class TicketUpdateRequest {
    idTicket: number;
    plannedStartDate: Date;
    plannedEndDate: Date;
    summary: string;
    description: string;
    idPriority: number;
    priority: string;
    idGroup: number;
    group: string;
    channel: string;
    idSubcategory: number;
    ticketCategory: Categoria = new Categoria();
    labels: Array<LabelTicket> = [];
    requesterName: string;
    requesterUsername: string;
    extraInfoList: Array<TicketExtraInfo> = [];
    public customerData: CustomerData = new CustomerData();
}

export class TicketAdvanceSearch {
    search: string;
    page: number;
    size: number;
    orderColumn: string;
    orderType: string;
    idTicket: number;
    folio: string;
    extra1: string;
    customerName: string;
    commercialName: string;
    summary: string;
    statusValue: string;
    label: string;
    ticketTypeName: string;
    date1: string;
    date2: string;
    idAssignee: number;

    statusList: Array<string>;
    openTickets: boolean = false;
    idGroup: number[];
    tipo: string;
    type: string;
    idType: string;
    category: string;
    idCategory: number;
    subcategory: string;
    idSubcategory: number;
    assignee: string;
    priority: string;
    idPriority: number;
    dateRegistrationStart: string;
    dateRegistrationEnd: string;
    dateDeliveryStart: string;
    dateDeliverytionEnd: string;
    contract: string;
    itsScaled?:boolean;
    sucursal: any;
    idSucursal: any;
    username:string;
    idTypeTicket: any;
    groupId: string;
    geofenceType: number;
    dimme: boolean;
}
export class TicketReschedule {
    idTicket: number;
    scheduledDate: number;
}
export interface ValuesForStatus {
    styleClass: string;
    status: string;
    color: string;
    percent: number;
}

export class GraficDashboard{
    startDate: any;
    idTicketCategory: number;
    categoryName: string;
    cuenta: number;
}

export class UserSessionHistory{
    idUserApp: number;
    selectDate: number;

}

export class Unassign {
    externalUnassign: boolean;
    idTicket:any;//any[];
    requesterView: {
        name: string;
        username: string;
    }
}

export class CancelTicketView {
    cancelReason: string;
    deviceId: string;
    externalCancel: boolean;
    requester: CancelTicketRequesterView = new CancelTicketRequesterView();
}

export class CancelTicketRequesterView {
    idUser: number;
    name: string;
    username: string;
}


export class UnassignAll {
    externalUnassign: boolean;
    idTickets:any;//any[];
    requesterView: {
        name: string;
        username: string;
    }
}

export enum Areas{
    MTTO = 1
}

export class GeoPosicionCherwellRequest {
    idTicket: number;
    longitud: number;
    latitud: number;
    fechaValidacion: string | null;
    categoriaFalla?: string;
}

export interface CloseClasification {
    folio: string
    fecha: number
    trabajo: number
    tipoTrabajo: number
    sucursal: number
    respuestas: Respuestas
}

export interface Respuestas {
    clasificacion: string
    red: string
    // tipoRed: string
}

export interface RedFlag {
    reason: string;
    registerDate: number;
    userNameRegistered: string;
    userIdRegistered: number;
    userNamePenalized: string;
    userIdPenalized: number;
    numberRule: number;
    typeRule: string;
    ignoreInCounter: boolean;
}
export class FibrasPleandasRequest {
  idTicket: number;
  fibras: string;
  metros?: number;
  fibrasPlaneadas: number;
  tamanioFibras:[];
  longitud: number;
  latitud: number;
  calibre: number;
}

export interface AllowedHoursResponse {
  allowed: boolean;
}
